import React, { useCallback, useState } from "react";
import SearchBar from "@/components/navbars/SearchBar";
import { colorStyles } from "@/utils/constants/constants";
import FilterOverlay from "@/components/overlays/FilterOverlay";
import { Button } from "@/components/ui/button";

interface TableHeadProps {
    search?: (searchText: string) => void;
    reset?: () => void;
    title: string;
    pageNo: number;
    dataLength: number;
    groups?: any;
    roles?: any;
    setDataLength: (dataLength: number) => void;
    button?: React.ReactNode;
    handleApplyFilter?: () => void;
    handleReset?: () => void;
    showFilter?: boolean;
    filter?: any;
    setFilter?: (filter: any) => void;
    options?: any;
    setPageNo?: (pageNo: number) => void;
    currentEnvo?: number;
    totalEnvo?: number;
    id: string;
}

function TableHead(props: TableHeadProps) {
    const [showSearchBar, setShowSearchBar] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState(null);

    const filterTitles = new Set(["Admins", "Users", "Envelopes", "Templates", "Forms"]);
    const showFilterOverlay =
        props.showFilter ?? filterTitles.has(props.title);

    const handleStatusChange = useCallback(
        (e: { target: { value: unknown } }) => {
            setSelectedStatus(e.target.value as any);
        },
        []
    );

    return showSearchBar ? (
        <SearchBar
            id={props.id}
            onHide={() => setShowSearchBar(false)}
            handleSearch={props.search}
            reset={props.reset}
            title={props.title}
        />
    ) : (
        <div className="gs-list-page-header">
            <div className="gs-list-page-title-wrap">
                <h5 className="gs-list-page-title" id={`${props.id}-title`}>
                    {props.title}
                </h5>
                <span className="gs-list-page-count" id={`${props.id}-data-count`}>
                    {props.currentEnvo ? `${props.currentEnvo} out of ${props.totalEnvo}` : null}
                </span>
            </div>
            <div className="gs-list-page-tools">
                {!(props.title === "Roles" || props.title === "Groups") && (
                    <Button
                        type="button"
                        variant="ghost"
                        size="icon"
                        onClick={() => setShowSearchBar(true)}
                        id={`${props.id}-search-btn`}
                    >
                        <em
                            id={`${props.id}-search-icon`}
                            className="icon ni ni-search"
                        />
                    </Button>
                )}
                {props.button && <div>{props.button}</div>}
                {showFilterOverlay && (
                    <FilterOverlay
                        id={props.id}
                        selectedStatusOption={selectedStatus}
                        setSelectedStatusOption={setSelectedStatus}
                        handleSelectChange={handleStatusChange}
                        handleApplyFilter={props.handleApplyFilter}
                        colorStyles={colorStyles}
                        options={props.options}
                        handleReset={props.handleReset}
                        groups={props.groups}
                        roles={props.roles}
                        filter={props.filter}
                        setFilter={props.setFilter ?? (() => {})}
                        title={props.title}
                        setPageNo={props.setPageNo}
                    />
                )}
            </div>
        </div>
    );
}

export default TableHead;
